import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import companyContingenciaService from "../services/companyContingenciaService";

export default function ContingenciaBanner() {
  const [estado, setEstado] = useState(null);

  const fetchEstado = async () => {
    try {
      const data = await companyContingenciaService.getEstado();
      setEstado(data);
    } catch (error) {
      console.error("Error obteniendo estado de contingencia:", error);
    }
  };

  useEffect(() => {
    fetchEstado();
    // Revisa cada 30 segundos por si se activa/desactiva desde otra pantalla
    const interval = setInterval(fetchEstado, 30000);
    return () => clearInterval(interval);
  }, []);

  if (!estado || !estado.modo_contingencia) return null;

  return (
    <div
      style={{
        background: "#dc2626",
        color: "#fff",
        padding: "10px 20px",
        display: "flex",
        alignItems: "center",
        gap: "10px",
        fontWeight: 600,
        fontSize: "14px",
        position: "sticky",
        top: 0,
        zIndex: 1000,
      }}
    >
      <AlertTriangle size={20} />
      <span>
        ⚠️ MODO CONTINGENCIA ACTIVADO — Las facturas se están firmando localmente y no se están enviando a Hacienda hasta que desactives este modo.
      </span>
    </div>
  );
}